import {Component, Input, OnInit} from '@angular/core';
import {
  CalendarioModificaOption,
  VisualizationCalendarModalEnum
} from "../../enums/calendar-event-titles-enum";
import {ModalFormConfiguration} from "../../interfaces/modal-configuration-interface";
import {ModalRoleEnum} from "../../enums/modal-enum";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonToolbar, IonTitle, IonSegment, IonSegmentButton, IonLabel, IonButton, IonItem, IonInput, IonIcon, IonModal, IonDatetime, IonButtons, ModalController } from '@ionic/angular/standalone';
import {format, parse, isBefore, isEqual} from "date-fns";
import {finalize, of, switchMap, takeUntil, tap} from "rxjs";
import {LoaderService} from "../../../services/loader.service";
import {UnsubscribeOnDestroy} from "../../abstracts/unsubscribe-on-destroy";
import {ManageErrorService, RequestTypesEnum} from "../../../services/manage-error.service";
import { HttpErrorResponse } from "@angular/common/http";

import {
  EventoCalendarioStudenteForm,
  EventoCalendarioType,
  StudentiService
} from "../../../../api-clients/generated/services";
import {NotificationService} from "../../../services/notification.service";
import { UpperCasePipe, DatePipe } from '@angular/common';


@Component({
    selector: 'app-choose-calendar-event-modal',
    templateUrl: './choose-calendar-event-modal.component.html',
    styleUrls: ['./choose-calendar-event-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonSegment, IonSegmentButton, IonLabel, IonButton, IonItem, IonInput, IonIcon, IonModal, IonDatetime, IonButtons, FormsModule, ReactiveFormsModule, UpperCasePipe, DatePipe]
})
export class ChooseCalendarEventModalComponent extends UnsubscribeOnDestroy implements OnInit {
  visualizzazione = VisualizationCalendarModalEnum;
  currentSegment: VisualizationCalendarModalEnum = VisualizationCalendarModalEnum.PASTA_IN_BIANCO;
  currentDay: string = '';
  defaultMessageFirstPart = 'Sicuro di voler prenotare pasta in bianco per la data ';
  modalMessagePasta: string = '';
  messageDateAssenza = 'Sicuro di voler indicare assenza per queste date?';
  confirmButtonText = 'Conferma';
  cancelButtonText = 'Annulla';
  todayDate: string | undefined;
  ctrlAssenzaInizio: FormControl = new FormControl();
  ctrlAssenzaFine: FormControl = new FormControl();
  currentStudenteId: string = '';
  errorMessageDate = 'Attenzione. La data di inizio non può essere più recente della data di fine. Si prega di riprovare con le date giuste'
  currentDate: string | undefined;

  @Input() set day(day: string) {
    this.currentDay = day;
  }

  @Input() set idStudente(idStudente: string) {
    this.currentStudenteId = idStudente;
  }

  @Input() segmentoIniziale?: VisualizationCalendarModalEnum;
  @Input() dataFineOverride?: string;

  constructor(private modalController: ModalController,
              private loaderService: LoaderService,
              private manageErrorService: ManageErrorService,
              private studenteControllerService: StudentiService,
              private notificationService: NotificationService) {
    super();

  }

  ngOnInit() {
    this.modalMessagePasta = this.defaultMessageFirstPart + this.currentDay + '?';

    this.todayDate = format(new Date(), "yyyy-MM-dd");
    this.currentDate = format(parse(this.currentDay, 'dd/MM/yyyy', new Date()), "yyyy-MM-dd");
    this.ctrlAssenzaInizio.setValue(this.currentDate);
    this.ctrlAssenzaFine.setValue(this.dataFineOverride ?? this.currentDate);

    if (this.segmentoIniziale) {
      this.currentSegment = this.segmentoIniziale;
    }
  }

  segmentVisualizationChanged($event: any) {
    console.log('SEGMENT CHANGE', $event.detail.value);
    this.currentSegment = $event.detail.value;
  }

  cancel() {
    return this.modalController.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirmPasta() {
    const options: CalendarioModificaOption = {
      tipoEvento: EventoCalendarioType.PASTAINBIANCO,
      giorni: [this.currentDay]
    };
    this.modificaCalendarioConfirm(options)

  }

  confirmAssenza() {
    const inizio = parse(this.ctrlAssenzaInizio.value, 'yyyy-MM-dd', new Date());
    const fine = parse(this.ctrlAssenzaFine.value, 'yyyy-MM-dd', new Date());
    if (isBefore(inizio, fine) || isEqual(inizio, fine)) {
      const giornoInizio = format(inizio, 'dd/MM/yyyy');
      const giornoFine = format(fine, 'dd/MM/yyyy');
      const options: CalendarioModificaOption = {
        tipoEvento: EventoCalendarioType.ASSENZA,
        giorni: [giornoInizio, giornoFine]
      };
      //this.modificaCalendarioConfirm()
      this.modificaCalendarioConfirm(options)
    } else {
      this.notificationService.openToast({
        message: this.errorMessageDate,
        color: 'danger'
      })
    }
  }

  modificaCalendarioConfirm(value: CalendarioModificaOption) {
    this.loaderService.showLoaderObserve$().pipe(
      switchMap(() => {
          if (value.tipoEvento === EventoCalendarioType.ASSENZA) {
            return this.addEventoCalendario$(value,
              EventoCalendarioType.ASSENZA
            )
          } else if (value.tipoEvento === EventoCalendarioType.PASTAINBIANCO) {
            return this.addEventoCalendario$(value,
              EventoCalendarioType.PASTAINBIANCO)
          } else {
            return of(null)
          }
        }
      ),
      takeUntil(this.destroy$),
      finalize(() => this.loaderService.hideLoader())
    ).subscribe({
      next: (value) => {
        this.loaderService.hideLoader();
        return this.modalController.dismiss(value, ModalRoleEnum.CONFIRM);
      }, error: (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.openToast({
          message: error.error.message, color: 'danger'
        })
      }
    });
  }

  addEventoCalendario$(option: CalendarioModificaOption, eventoType: EventoCalendarioType) {
    const isOptionGiorniPresent = (eventoType !== EventoCalendarioType.PASTAINBIANCO);
    const data_inizio = isOptionGiorniPresent ? option.giorni![0]! : this.currentDay!;
    const data_fine = isOptionGiorniPresent ? option.giorni!.at(-1)! : this.currentDay!;
    const body: EventoCalendarioStudenteForm = {
      data_inizio: data_inizio,
      data_fine: data_fine,
      tipo_evento: eventoType,
    }
    return this.studenteControllerService.addEventoCalendario(body, this.currentStudenteId)
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
